import { useEffect } from "react";

import { useUserMe } from "@/data_source/services/UserService";
import { UserStore } from "@/stores/user-store";
import request from "@/utils/request";

/**
 * Owns the sole session bootstrap for `GET /api/users/me` above RouteGuard.
 *
 * RouteGuard waits on `UserStore` when a token is present. AppHome used to be
 * the only `useUserMe()` caller, but it sits behind that guard — so waiting
 * never mounted AppHome and `/me` never ran (smoke deadlock on #3536).
 */
export function CurrentUserBootstrap(): null {
  const [loginUser] = useUserMe();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || token.match(/null/i)) {
      request.setGlobalHeader({ Authorization: "" });
      return;
    }
    request.setGlobalHeader({ Authorization: `Token ${token}` });
  }, []);

  useEffect(() => {
    // Keep the previous store value while /me is in flight; logout clears null.
    if (!loginUser?.data) return;
    UserStore.getInstance().add(loginUser.data);
  }, [loginUser]);

  return null;
}
